import * as images from "@/components/images/Images_second";
import { SupportCardProps } from "@/components/screen/global-components/support/SupportCard";
import { ROUTES } from "@/constants";

const supportCards: SupportCardProps[] = [
  {
    title: "Get  a quote",
    description:
      "If you have a project(s) in mind or want to speak to our sales team, submit your project details, requirements, any questions, and we’ll reach out within 24 hours. ",
    href: ROUTES.getQuote,
    linkLabel: "Learn more",
    imageUrl: images.support1,
  },
  {
    title: "FAQ",
    description:
      "Get immediate answers to your questions on translation best practices, our services, pricing, and more.",
    href: "/faq",
    linkLabel: "Learn more",
    imageUrl: images.support2,
  },
  {
    title: "Call us",
    description:
      "Reach us at (833) 551-1381 Monday through Friday between the hours of 9 a.m. to 5 p.m EST. Outside of these hours, please leave us a message and we’ll return your call during business hours.",
    imageUrl: images.support3,
  },
];

export const supportData = {
  title: "Need more info? We're here to help.",
  description: null,
  cards: supportCards,
};
